import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import { getUser } from '../../../store/alpha'
import { 
  getPublicClassList, fetchPublicClassList,
  getProviderIndex, fetchProviderIndex, getTopicIndex,
  fetchTopicIndex
} from '../../../store/client'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import Button from '../../../shared/ui/Button'
import Image from '../../../shared/ui/Image'
import Grid from '../../../shared/ui/Grid'
import Link from '../../../shared/ui/Link'
import { capitalize } from '../../../shared/utilities/helpers'

import ProviderCard from '../views/ProviderCard'
import PublicClassCard from '../views/PublicClassCard'
import CourseList from '../views/CourseList'
import ProjectFormView from '../views/ProjectFormView'

import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import LinearProgress from '@material-ui/core/LinearProgress'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import CircularProgress from '@material-ui/core/CircularProgress'
import Paper from '@material-ui/core/Paper'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'

import DropDownIcon from '@material-ui/icons/ArrowDropDown'
import CustomCourseIcon from '@material-ui/icons/Dvr'
import FilterIcon from '@material-ui/icons/FilterList'
import RightIcon from '@material-ui/icons/ChevronRight'

const styles = theme => ({
  root: {
    position: 'relative',
    padding: theme.spacing(2)    
  },
  linearProgress: {
    top: 0,
    left: 0,
    position: 'absolute',
    height: '2px',
    overflow: 'hidden',
    width: '100%',
    zIndex: 10
  },  
  emptyText: {
    fontSize: theme.typography.body1.fontSize,    
    color: '#888'
  },
  cardContent: {
    padding: theme.spacing.unit * 1.5,
  },
  cardTitleContainer: {
    height: '4.5rem',
    marginBottom: theme.spacing(.5),
    overflow: 'hidden'
  },
  cardTitle: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 600,
  },
  cardDate: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 400,
    color: theme.palette.secondary.main,
    //fontWeight: 600,
    //color: '#666'
  },
  cardClassInfo: {
    fontWeight: 400,
    color: '#444'
  },
  cardPrice: {
    fontWeight: 400,
    color: '#444'
  },
  cardAvatar: {
    width: theme.spacing(5),
    height: theme.spacing(5),    
  },
  cardProviderName: {
    fontWeight: 600,
    color: '#aaa'    
  },
  sectionTitle: {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: 800,
    //color: theme.palette.primary.main
  },
  sectionSubtitle: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 800
  },  
  filterPanel: {
    //padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
    width: '100%'
  },
  providerContainer: {
    rowGap: '1em'
  },
  providerItem: {
    padding: theme.spacing.unit * 1.5,    
  },
  providerItemAvatar: {
    width: theme.spacing(8),
    height: theme.spacing(8),    
  },
  providerItemName: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 600,
  },
  selectedItem:{
    background: 'rgb(40, 109, 204)',
    color: 'white',
    '&:hover':{
      background: 'rgb(40, 109, 204)'
    }
  }
})

const FilterPanel = ({ theme, classes, categories, categoryKey, user, ...props }) => {
  const navigationContext = useContext(NavigationContext)
  const [openDialog, setOpenDialog] = useState(false)

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOpenCustomOrder = () => {
    if (!user.isLoggedIn) {
      alert('You must login before order.')
      return
    } else {
      if (!user.companyInfo) {
        alert('You must have company before order.')
        return
      } else {
        setOpenDialog(true)
      }
    }
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div elevation={2}
      className={classes.filterPanel}    
      >
      <Box display='flex' justifyContent='flex-start' alignItems='center'>
        <FilterIcon />      
        <Box display='flex' flexGrow={1}>
          <Button icon={DropDownIcon} onClick={handleClick}>
            {categoryKey ? capitalize(categoryKey.replace('-', ' ')) : 'All Categories'}
          </Button>
          
          {/*          
          <Box ml={2} />
          <Button icon={DropDownIcon}>
            All Delivery Methods
          </Button>
          <Box ml={2} />
          <Button icon={DropDownIcon}>
            All Cities
          </Button>
          */}
          
        </Box>
        
        <Box display='flex'>
          <Button icon={CustomCourseIcon} variant='contained' onClick={handleOpenCustomOrder}>
            Order Custom Course
          </Button>          
        </Box>
        
        { openDialog &&
          <ProjectFormView 
            showDialog={true}
            onClose={() => setOpenDialog(false)}
            type={'custom'}
          />
        }
          
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem
            onClick={()=>{navigationContext.openLink('/');setAnchorEl(null);}}
            className={categoryKey === '' ? classes.selectedItem : ''}
            >
              All Categories
          </MenuItem>
          { categories.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)).filter(c => c.key !== 'default').map( item =>
            <MenuItem
              onClick={()=>{item.key !== 'default' ? navigationContext.openLink('/browse/'+item.key) : navigationContext.openLink('/');setAnchorEl(null);}}
              className={categoryKey === item.key ? classes.selectedItem : ''}
              >
                {item.name !== 'Default' ? item.name : 'All Categories'}
            </MenuItem>
          )}
        </Menu>
      </Box>
    </div>
  )
}

const BrowseController = ({ theme, classes, view='all', ...props }) => {

  const { courses, categoryKey, publicClasses, fetchPublicClasses,
    fetchCategories, categories, providers, fetchProviders, query, user } = props

  const [itemSize, setItemSize] = useState('small')  
  
  const navigationContext = useContext(NavigationContext)

  useEffect(() => {
    fetchPublicClasses()
    fetchProviders()
    fetchCategories()
  }, [])
    
  const getCourseDetailLink = (row) => {
    return `/course/${row.uid}`
  }

  const getProviderDetailLink = (row) => {
    return `/provider/${row.uid}`
  }
    
  const getPublicClassDetailLink = (row) => {
    return `/course/${row.course.uid}?date=${row.training_date}`
  }
  
  const smUp = useMediaQuery(theme.breakpoints.up('sm'))
  const maxRowCount = smUp ? 1 : 2

  const publicClassList = publicClasses.lastFetched ? publicClasses.data.records : []
  const filteredPublicClass = categoryKey ? 
    publicClassList.filter(item => item.course && item.course.category_name.replace(' ', '-').toLowerCase().includes(categoryKey)) : publicClassList

  const resultFilterClasses = query !== '' ? filteredPublicClass.filter(item => item.course.name.toLowerCase().indexOf(query) > -1) : filteredPublicClass

  const providerList = providers.lastFetched ? providers.data.records : []
  const filteredProvider = query !== '' ? providerList.filter(item => item.name.toLowerCase().indexOf(query) > -1) : providerList
  
  let selfLocation = "/browse/"
  if (categoryKey)
    selfLocation = `/browse/${categoryKey}/`
  
  let pageTitle = null
  if (categoryKey) {
    pageTitle = capitalize(categoryKey.replace('-', ' '))
    if (view === 'public-classes')
      pageTitle = "All Upcoming Public Classes in " + pageTitle
    else if (view === "courses")
      pageTitle = "All Private Courses in " + pageTitle
    else if (view === "providers")
      pageTitle = "All Training Providers in " + pageTitle      
  }
  else {
    if (view === 'public-classes')
      pageTitle = "All Upcoming Public Classes"
    else if (view === "courses")
      pageTitle = "All Private Courses"
    else if (view === "providers")
      pageTitle = "All Training Providers"
  }
  
  return (
    <div className={classes.root}>
      
      { false && (courses.isFetching || publicClasses.isFetching) &&
        <div className={classes.linearProgress}>
          <LinearProgress />
        </div>
      }      
      
      <Container maxWidth='xl'>
        { !categoryKey && view === 'all' && (
          <Paper elevation={2}
            style={{
              overflow: 'hidden',
              marginBottom: theme.spacing(4)
            }}>
            <Image
              aspectRatio={2.4} 
              src="https://media.pasartrainer.com/45104640091720/image/content/contentfield/6d133d5f-2e80-4fd1-ab54-fe20c4a884f0.jpg"
            />
          </Paper>
          )
        }
        
        <Box mt={0}>
          <FilterPanel theme={theme} classes={classes} user={user} categoryKey={categoryKey} categories={categories.lastFetched ? categories.data.records : []}
            />
        </Box>
        
        { pageTitle &&
          <Box mt={2} className={classes.sectionTitle}>
            { pageTitle }
          </Box>
        }

        {/* { query !== '' &&
          <Box mt={2}>
            <Typography variant='h6'>
              Searching : { query }
            </Typography>
          </Box>
        } */}
        
        { (view == 'all' || view == 'public-classes') &&
          <>
            { view === 'all' &&          
            <Box mt={4} display='flex' alignItems='center'>
              <Box flexGrow={1} className={classes.sectionSubtitle}>
                Upcoming Public Classes ({resultFilterClasses.length})
              </Box>
              <Box ml={2}>
                <Button component={Link} 
                  to={`${selfLocation}public-classes`}
                  icon={RightIcon}
                  iconPosition='right'
                  >
                  View All                  
                  </Button>            
              </Box>
            </Box>
            }            
            <Box mt={3}> 
              <Grid
                size={itemSize} 
                maxRowCount={view === 'all' ? maxRowCount : -1}
                items={resultFilterClasses}
                renderItem={(item, index) => (
                  <PublicClassCard theme={theme} classes={classes}
                    item={item}
                    linkTo={getPublicClassDetailLink(item)}
                    />
                )}
              /> 
              
              { !publicClasses.isFetching && publicClasses.lastFetched && resultFilterClasses.length <= 0 &&
                <Box mt={2} display='flex' justifyContent='center' className={classes.emptyText}>
                  No upcoming public classes in this category
                </Box>
              }
              
              { publicClasses.isFetching &&
                <Box display='flex' justifyContent='center' style={{ padding: theme.spacing(2) }}>
                  <CircularProgress size='1.5rem' disableShrink={true} />        
                </Box>
              }
              
              { false && view === 'all' && publicClasses.lastFetched && resultFilterClasses.length > 0 &&
                <Box mt={2} display='flex' justifyContent='center'>
                  <Button component={Link} to={`${selfLocation}public-classes`}>View All</Button>
                </Box>
              }
              
            </Box>
          </>
        }
        
        { (view == 'all' || view == 'courses') &&
          <>             
            <Box mt={3}>  
              <CourseList 
                theme={theme}
                classes={classes}
                view={view}
                itemSize={itemSize}
                maxRowCount={view === 'all' ? maxRowCount : -1}
                selfLocation={selfLocation}
                {...props}
              />                 
            </Box>
          </>
        }

        { (view == 'all' || view == 'providers') &&
          <>
            { view === 'all' &&          
            <Box mt={5} display='flex' alignItems='center'>
              <Box flexGrow={1} className={classes.sectionSubtitle}>
                Training Providers ({filteredProvider.length})
              </Box>
              <Box ml={2}>
                <Button component={Link} 
                  to={`${selfLocation}providers`}
                  icon={RightIcon}
                  iconPosition='right'
                  >
                  View All
                  </Button>            
              </Box>
            </Box>          
            }            
            
            <Box mt={3}>      
              <Grid theme={theme} classes={classes}
                className={classes.providerContainer}
                size={itemSize} 
                maxRowCount={view === 'all' ? maxRowCount : -1}
                items={filteredProvider}
                renderItem={(item, index) => (
                  <ProviderCard theme={theme} classes={classes}
                    item={item}
                    linkTo={getProviderDetailLink(item)}
                    showVisitButton={true}
                    target="_self"
                    />
                )}
              />
    
              { !providers.isFetching && providers.lastFetched && filteredProvider.length <= 0 &&
                <Box mt={2} display='flex' justifyContent='center' className={classes.emptyText}>
                  No training providers found in this category
                </Box>
              }
              
              { providers.isFetching &&
                <Box display='flex' justifyContent='center' style={{ padding: theme.spacing(2) }}>
                  <CircularProgress size='1.5rem' disableShrink={true} />        
                </Box>
              }
              
              { false && view === 'all' && providers.lastFetched && filteredProvider.length > 0 &&
                <Box mt={2} display='flex' justifyContent='center'>
                  <Button component={Link} to={`${selfLocation}providers`}>View All</Button>
                </Box>
              }
              
            </Box>        
          </>
        }
        <Box mt={10} />
      </Container>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  let categoryKey = ownProps.match.params.categoryKey || ''
  let query = new URLSearchParams(ownProps.location.search).get('q') || ''

  return {
    categoryKey: categoryKey,
    query: query,
    publicClasses: getPublicClassList(state),
    providers: getProviderIndex(state, "", null),
    categories: getTopicIndex(state, '', null),
    user: getUser(state),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

  return {
    fetchPublicClasses: () => {
      dispatch(fetchPublicClassList(true))
    },
    fetchProviders: () => {
      dispatch(fetchProviderIndex("", null))
    },    
    fetchCategories: () => {
      dispatch(fetchTopicIndex('',null, true))
    }
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(BrowseController)
)
